import { render, staticRenderFns } from "./RedefinicionFilas.vue?vue&type=template&id=04a8fbfe"
import script from "./RedefinicionFilas.vue?vue&type=script&lang=js"
export * from "./RedefinicionFilas.vue?vue&type=script&lang=js"
import style0 from "./RedefinicionFilas.vue?vue&type=style&index=0&id=04a8fbfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports